function At802Plane() {
  return (
    <g className="at802-plane">
      <g className="at802-prop">
        <rect height="14" width="1" x="11" y="10" />
        <rect height="2" width="2" x="12" y="16" />
      </g>
      <rect className="at802-spinner" height="4" width="2" x="14" y="15" />

      <rect className="at802-body" height="6" width="5" x="16" y="13" />
      <rect className="at802-body" height="6" width="34" x="21" y="13" />
      <rect className="at802-body" height="4" width="8" x="55" y="14" />

      <rect className="at802-stripe" height="1" width="40" x="21" y="17" />

      <rect className="at802-cockpit" height="2" width="15" x="31" y="11" />
      <rect className="at802-cockpit" height="2" width="12" x="33" y="9" />
      <rect className="at802-cockpit" height="2" width="9" x="35" y="7" />
      <rect className="at802-cockpit" height="1" width="5" x="37" y="6" />
      <rect className="at802-canopy-glass" height="1" width="3" x="38" y="8" />

      <rect className="at802-body" height="12" width="3" x="60" y="6" />
      <rect className="at802-stripe" height="3" width="3" x="60" y="6" />
      <rect className="at802-body" height="2" width="8" x="60" y="13" />
      <rect className="at802-stripe" height="2" width="2" x="66" y="13" />

      <rect className="at802-wing" height="2" width="64" x="6" y="19" />
      <rect className="at802-stripe" height="2" width="3" x="6" y="19" />
      <rect className="at802-stripe" height="2" width="3" x="67" y="19" />

      <rect className="at802-strut" height="4" width="2" x="24" y="19" />
      <rect className="at802-strut" height="4" width="2" x="44" y="19" />

      <rect className="at802-float" height="3" width="40" x="16" y="23" />
      <rect className="at802-float" height="2" width="2" x="14" y="22" />
      <rect className="at802-float" height="1" width="2" x="12" y="21" />
      <rect className="at802-scoop" height="1" width="40" x="16" y="25" />
      <rect className="at802-wheel" height="2" width="3" x="22" y="26" />
      <rect className="at802-wheel" height="2" width="3" x="40" y="26" />
    </g>
  );
}

export { At802Plane };
